export default "__VITE_ASSET__D9H45XHJ__"